import preloadChunks from '@/routes/preloadChunks.util';

const contentCredentialsRoutes = [
  {
    path: 'content-credentials',
    lazy: async () => ({
      Component: (await preloadChunks['contentCredentials.main']()).default,
    }),
  },
];

export default contentCredentialsRoutes;
